import { withInstall } from '../helpers';

import Row from './src/QRow.vue';

export const QRow = withInstall(Row);

export type { QRowProps, QRowInstance } from './src/types';
